<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pt-0 tw-flex tw-items-center tw-justify-between">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Sales Tax Rates</h1>
        <base-button :disabled="!connected" @click="openCreateModal"
          ><template v-slot:icon>
            <plus-icon /> </template
          >Add Tax Rate</base-button
        >
      </base-content>
    </div>
    <base-content>
      <div v-if="connected === false" class="tw-flex tw-items-center tw-w-full tw-justify-between tw-border tw-border-yellow-300 tw-bg-yellow-50 tw-rounded-lg tw-p-3 tw-mb-3">
        <span class="tw-text-yellow-600 tw-w-2/3">Tax rates are linked to your merchant account and are only available after connecting your merchant account.</span>
        <base-button type="primary" color="primary" @click="$router.push(`/businesses/${businessId}/business/merchant`)">Connect Merchant Account</base-button>
      </div>
      <base-table :loading="isLoading" :fields="fields" :items="items">
        <template #name="{item: taxRate}">
          <div>{{ taxRate.name }}</div>
          <div class="tw-text-gray-500 tw-text-xs">{{ taxRate.description }}</div>
        </template>
        <template #status="{item: taxRate}">
          <div>{{ taxRate.active === true ? "Active" : "Inactive" }}</div>
        </template>
        <template #jurisdiction="{item: taxRate}">
          <div>{{ taxRate.jurisdiction }}</div>
        </template>
        <template #percentage="{item: taxRate}">
          <div>{{ taxRate.percentage }} %</div>
        </template>
        <template #actions="{item: taxRate}">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <base-button type="flat" @click="openEditModal(taxRate)">
              <template v-slot:icon>
                <edit-icon /> </template
              >Edit
            </base-button>
          </div>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Results
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-flex-col">
              <base-skeleton-loader class="tw-h-4 tw-w-36 tw-mb-2" />
              <base-skeleton-loader class="tw-h-3 tw-w-16" />
            </div>
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-28 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-8 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-justify-between">
              <base-skeleton-loader class="tw-h-6 tw-w-12" />
            </div>
          </td>
        </template>
      </base-table>
    </base-content>
    <create-tax-rate ref="createModal" :business-id="businessId" @created="loadRates" />
    <edit-tax-rate ref="editModal" :business-id="businessId" @edited="loadRates" />
  </div>
</template>
<script>
import CreateTaxRate from "@/views/business/tax-rates/components/CreateTaxRate";
import EditTaxRate from "@/views/business/tax-rates/components/EditTaxRate";
import { mapGetters } from "vuex";
import { PlusIcon, EditIcon } from "@/assets/svgs";

export default {
  name: "BusinessTaxRates",
  components: {
    CreateTaxRate,
    EditTaxRate,
    PlusIcon,
    EditIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      fields: [
        { title: "Name", key: "name", thClass: "" },
        { title: "Jurisdiction", key: "jurisdiction", thClass: "" },
        { title: "Status", key: "status", thClass: "" },
        { title: "Tax %", key: "percentage", thClass: "tw-whitespace-nowrap" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      ],
    };
  },
  computed: {
    ...mapGetters("businessActivation", { hasMerchantProcessing: "hasMerchantProcessing" }),
    ...mapGetters("organization", ["organization"]),
    connected() {
      if (this.organization.isActive || this.hasMerchantProcessing) return true;
      else return false;
    },
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Sales Tax Rates" }];
    },
  },
  mounted() {
    if (this.connected) this.loadRates();
  },
  methods: {
    openCreateModal() {
      this.$refs.createModal.show();
    },
    openEditModal(item) {
      this.$refs.editModal.show(item);
    },
    loadRates() {
      this.isLoading = true;

      this.$axios
        .get(`/businesses/${this.businessId}/taxrates`)
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: `Failed to load tax rates`,
            message: `We had a problem retrieving the list of tax rates. Please reload the page to try again.`,
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
